import type { ThunkAction } from '@reduxjs/toolkit';
import type { RootState } from 'store/index';
import { UpcomingActionsService } from 'store/services/upcoming-actions.service';
import { carsActions, carsSelectors } from 'store/slices/cars/config';
import { upcomingActionsMethods } from './config';
import type { UpcomingAction } from './upcoming-actions.slice';

export interface GetUpcomingActionsParams {
  dateRange: Record<string, Date>;
}
export const getAllUpcomingActions =
  (
    params?: GetUpcomingActionsParams,
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(true));
      const response =
        await UpcomingActionsService.getAllUpcomingActions(params);
      dispatch(upcomingActionsMethods.setUpcomingActions(response));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(false));
    }
  };

export const createNewUpcomingAction =
  (
    payload: Omit<UpcomingAction, 'id'>,
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch) => {
    try {
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(true));
      const response = await UpcomingActionsService.createNew(payload);
      dispatch(upcomingActionsMethods.setNewUpcomingAction(response));
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(false));
    }
  };

export const updateUpcomingActionThunk =
  (payload: UpcomingAction): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch, getState) => {
    try {
      const selectedCar = carsSelectors.selectSelectedCar(getState());
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(true));
      const response = await UpcomingActionsService.update(payload);
      dispatch(upcomingActionsMethods.updateUpcomingAction(response));
      if (selectedCar?.id) {
        dispatch(
          carsActions.setSelectedCar({
            ...selectedCar,
            upcomingActions: (selectedCar.upcomingActions || []).map((item) =>
              item.id === response.id ? response : item,
            ),
          }),
        );
      }
    } catch (err: any) {
      throw new Error(err);
    } finally {
      dispatch(upcomingActionsMethods.setUpcomingActionsPendingStatus(false));
    }
  };
